import React from "react";
import { fontColorEnum } from "@/utils/enum";

const SplitLineSection = ({ fields }) => {
  const color = (() => {
    switch (fields?.lineColor?.value?.toLowerCase()) {
      case fontColorEnum.blue:
        return "#0400CF";
      case fontColorEnum.red:
        return "#DC4041";
      case fontColorEnum.grey:
        return "#DBDBDB";
      default:
        return "#111111";
    }
  })();
  return (
    <div
      style={{
        paddingTop: "10px",
        paddingBottom: "30px",
      }}
    >
      <div
        style={{
          width: "100%",
          height: `${fields?.lineHeight?.value}px`,
          backgroundColor: color,
        }}
      />
    </div>
  );
};

export default SplitLineSection;
